<template>
  <div class="video-playlist">
    <div v-if="status.ready">
      <div class="grid-x grid-padding-x">
        <div class="cell small-12 medium-12 large-7">

          <vue-plyr 
            ref="plyr" 
            :options="plyrOptions"
            style="--plyr-color-main: #01B256;">

            <video
              v-if="video.provider == 'local'"
              controls
              crossorigin
              playsinline
              :data-poster="posterImage">
              <source :src="video.url" />
            </video>
            <div
              v-else
              :data-plyr-provider="video.provider"
              :data-plyr-embed-id="video.embed_id"
              class="plyr__video-embed">
            </div>

          </vue-plyr>

        </div>
        <div class="cell small-12 medium-12 large-5">
          <playlist
            :videos="videos"
            :curr-video="video"
            @select-video="selectVideo">
          </playlist>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Playlist from '@/Playlist.vue'

export default {
  name: 'App',
  components: {
    Playlist
  },
  data () {
    return {
      status: {
        ready: false,
        busy: false,
        error: false,
      },
      player: false,
      video: false,
      autoplay: false
    }
  },
  methods: {
    init () {
      if (this.videos) {
        this.status.ready = true
        this.video = this.videos[0]
      }
    },
    selectVideo (video) {
      console.log('player?', this.$refs.plyr.player)
      this.video = video
      this.setSource()
      //const el = this.$root.$el
      //this.$nextTick(() => {
        //VueScrollTo.scrollTo(self.$refs['section-' + name][0], 100, {offset: -20})
        //VueScrollTo.scrollTo(el, 100, {offset: -20})
      //})
    },
    setSource () {
      this.$refs.plyr.player.source = this.source
    }
  },
  computed: {
    config () {
      return this.$options.config
    },
    plyrOptions () {
      return {
        autoplay: this.autoplay
      }
    },
    posterImage () {
      if (this.video.poster_image) {
        return this.video.poster_image.large
      }
      return false
    },
    source () {
      let source_obj = {
        type: 'video',
        title: this.video.title,
        sources: []
      }

      if (this.video.provider == 'local') {
        source_obj.sources.push({
          src: this.video.url
        })
        source_obj.poster = this.posterImage
      }

      if (this.video.provider == 'youtube') {
        source_obj.sources.push({
          provider: 'youtube',
          src: this.video.embed_id
        })
      }

      console.log('source obj', source_obj)
      return source_obj
    },
    videos () {
      if (this.config && this.config.videos.length) {
        return this.config.videos
      }
      return false
    }
  },
  mounted () {
    //this.player = this.$refs.plyr.player
    this.init()
  }
}
</script>
